import React from 'react';
import { useAuth } from './AuthProvider';
import { useAgency } from './AgencyProvider';
import './UserInfoBox.css';

const UserInfoBox: React.FC = () => {
  const { isAuthenticated } = useAuth();
  const { agency, loading } = useAgency();

  if (!isAuthenticated || loading) {
    return null;
  }

  if (!agency) {
    return (
      <div className="user-info-banner">
        <div className="user-info-row">
          <span className="info-value">We Insure</span>
        </div>
      </div>
    );
  }

  return (
    <div className="user-info-banner">
      <div className="user-info-row">
        <span className="info-value">{agency.dba_name || agency.name}</span>
        <span className="info-value">Branch {agency.branch_code}</span>
        {agency.cohort && <span className="info-value">{agency.cohort}</span>}
        {agency.account_manager && <span className="info-value">{agency.account_manager_name || 'TBD'}</span>}
      </div>
    </div>
  );
};

export default UserInfoBox;
